export const scheduleInitialValues = {
  cdLinhaQuadroHorario: '',
  cdLinha: '',
  cdLinhaSituacao: '',
  cdSolicitacao: '',
  cdRevisao: '',
  nuProcesso: '',
  nuProcessoSei: '',
  cdProcesso: '',
  dtCadastro: new Date(),
  dtVigencia: null,
  nuApostila: '',
  idFile: '',
  boAssinado: false,
  deObservacao: '',
  linha: {},
  tipoItinerario: {},
  situacao: {},
  horarios: [],
};

